import { getPurchaseOrdersSetup, getPurchaseOrders, deletePurchaseDetails, getPurchaseExcel } from '@/services/suppliers.js'
import jsonData from './jsonData.js'
import allButton from '@/components/allButton'
import searchForm from '@/components/searchForm'
import createTable from '@/components/createTable'
import dialogEffect from '@/components/dialogEffect'
import { mixin } from '@/mixins/mixin'
export default {
  name: 'SupplierList',
  mixins: [mixin],
  components: {
    searchForm,
    createTable,
    allButton,
    dialogEffect
  },
  data () {
    return {
      tableDataItem: jsonData.tableDataItem,
      isTabChange: false,
      total_amount: 0
    }
  },
  watch: {
    $route (to, from) {
      // console.log(from)
      // if (from.name === 'managerUserOrderView') {
      //   this.$nextTick(() => {
      //     this.search()
      //     this.$refs.createTable.$refs.table.doLayout()
      //   })
      // }
    }
  },
  created () {
    this.queryData(getPurchaseOrdersSetup)
  },
  activated () {
    if (this.isActive) this.queryData(getPurchaseOrdersSetup)
    this.isActive = true
  },
  methods: {
    // 点击操作按钮
    async handleClick (type, data) {
      if (type === 'create') {
        this.$router.push({
          name: 'purchaseAdd'
        })
      }
      if (type?.action === 'view') {
        this.$router.push({
          name: 'purchaseDetail',
          params: {
            id: data.id.value
          }
        })
      }
      if (type?.action === 'create') {
        this.$router.push({
          name: 'purchaseAdd'
        })
      }
      if (type?.action === 'edit') {
        this.$router.push({
          name: 'purchaseEdit',
          params: {
            id: data.id.value
          }
        })
      }
      if (type?.action === 'destroy') {
        this.deleteClick(data, deletePurchaseDetails)
      }
    },
    handleSwitchChange (data) {},
    forwardToPage (data, name) {
      if (name === 'supplier') {
        this.$router.push({
          name: 'suppliersDetail',
          params: {
            id: data.id
          }
        })
      }
    },
    tabChange (index) {
      this.isTabChange = true
      const params = {
        scope: this.tabData[index].value
      }
      this.queryData(getPurchaseOrdersSetup, params)
    },
    handleExport () {
      this.$refs.searchForm.commonOperate(getPurchaseExcel, (data) => {
        this.$router.push({
          name: 'suppliersManagerPurchaseDownloadCenter',
          params: { data }
        })
      }, this)
    },
    // 查询
    search (data) {
      if (this.isTabChange) {
        this.isTabChange = false
        return
      }
      if (data) this.searchData = data
      const { page, per_page } = this.pageData
      Object.assign(this.searchData, { page, per_page })
      this.loading = true
      getPurchaseOrders(this.searchData).then(res => {
        if (res.data) {
          this.tableData = res.data.objects
          this.tabData = res.data.scopes
          this.total_amount = res.data.total_amount
          Object.assign(this.pageData, res.data.pagination)
        }
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
